export class Vertical {
  constructor(id, name, productId, tenantId, searchConfig, features) {
    this.id = id;
    this.name = name;
    this.productId = productId;
    this.tenantId = tenantId;
    this.searchConfig = searchConfig;
    this.features = features || {
      call: false,
      unblock: false,
      getOtp: false,
      resetOtp: false,
      orderManagement: false,
    };
  }
}

class VerticalRegistry {
  static _VERTICALS = {
    1: new Vertical(
      1,
      "IL",
      "300",
      "1",
      { admission_number: false, phone: true, uam_id: true },
      {
        call: true,
        unblock: false,
        getOtp: true,
        resetOtp: true,
        orderManagement: true,
      },
    )
  };

  static getVertical(id) {
    return this._VERTICALS[id];
  }

  static getVerticalByName(name) {
    return Object.values(this._VERTICALS).find(
      (vertical) => vertical.name === name,
    );
  }
  static getAllVerticals() {
    return Object.values(this._VERTICALS);
  }
}

export default VerticalRegistry;
